export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';
export const SIN_REDUCER_NECESARIO_SUCCESS = 'SIN_REDUCER_NECESARIO_SUCCESS';

export const LOAD_TAG_LIST_SUCCESS = 'LOAD_TAG_LIST_SUCCESS';
export const LOAD_TAG_SUCCESS = 'LOAD_TAG_SUCCESS';
export const SAVE_TAG_SUCCESS = 'SAVE_TAG_SUCCESS';
export const GET_TAGS_COMBO_SUCCESS = 'GET_TAGS_COMBO_SUCCESS';
export const BORRAR_TAG_SUCCESS = 'BORRAR_TAG_SUCCESS';
export const ACTIVAR_TAG_SUCCESS = 'ACTIVAR_TAG_SUCCESS';
export const SET_FILTRO_TAG = 'SET_FILTRO_TAG';
export const GET_TAG_COMBO_SUCCESS = 'GET_TAG_COMBO_SUCCESS';

export const ON_SHOW_SIDEBAR_IZQUIERDA = 'ON_SHOW_SIDEBAR_IZQUIERDA';
export const ON_SIDEBAR_IZQUIERDA = 'ON_SIDEBAR_IZQUIERDA';
export const ADD_TOKEN = 'ADD_TOKEN';
export const SET_IDIOMA = 'SET_IDIOMA';
export const SAVE_HOME_CAT_SUCCESS = 'SAVE_HOME_CAT_SUCCESS';

export const SET_STRINGS_SUCCESS='SET_STRINGS_SUCCESS';
export const SET_PAGINA_ACTUAL="SET_PAGINA_ACTUAL";

export const LOAD_CURSOS_CARRUSEL_SUCCESS = 'LOAD_CURSOS_CARRUSEL_SUCCESS';
export const LOAD_CURSOS_GRATUITOS_SUCCESS = 'LOAD_CURSOS_GRATUITOS_SUCCESS';
export const LOAD_HOME_INFO_SUCCESS = 'LOAD_HOME_INFO_SUCCESS';
export const LOAD_CURSOS_ACTUALES_SUCCESS = 'LOAD_CURSOS_ACTUALES_SUCCESS';



export const LOAD_CONTENIDO_LIST_SUCCESS = 'LOAD_CONTENIDO_LIST_SUCCESS';
export const LOAD_CONTENIDO_SUCCESS = 'LOAD_CONTENIDO_SUCCESS';
export const SAVE_CONTENIDO_SUCCESS = 'SAVE_CONTENIDO_SUCCESS';
export const GET_CONTENIDOS_COMBO_SUCCESS = 'GET_CONTENIDOS_COMBO_SUCCESS';
export const BORRAR_CONTENIDO_SUCCESS = 'BORRAR_CONTENIDO_SUCCESS';
export const ACTIVAR_CONTENIDO_SUCCESS = 'ACTIVAR_CONTENIDO_SUCCESS';
export const SET_FILTRO_CONTENIDO = 'SET_FILTRO_CONTENIDO';
export const GET_CONTENIDO_COMBO_SUCCESS = 'GET_CONTENIDO_COMBO_SUCCESS';
export const LOAD_MODULOCONTENIDO_SUCCESS = "LOAD_MODULOCONTENIDO_SUCCESS";

export const LOAD_CONTENIDOSLIST_SUCCESS='LOAD_CONTENIDOSLIST_SUCCESS';

export const UPDATE_TABLA = 'UPDATE_TABLA';
export const GET_HOME_CAT_SUCCESS = 'GET_HOME_CAT_SUCCESS';
export const SET_MENU_SUCCESS = 'SET_MENU_SUCCESS';
export const SAVE_DOCUMENTO_ADJUNTO_SUCCESS = 'SAVE_DOCUMENTO_ADJUNTO_SUCCESS';

export const SET_FOTO_PERFIL_SUCCESS = 'SET_FOTO_PERFIL_SUCCESS';
export const LOAD_INSTRUCTORES_SUCCESS = 'LOAD_INSTRUCTORES_SUCCESS';
export const LOAD_PREGUNTAS_FRECUENTES_SUCCESS = 'LOAD_PREGUNTAS_FRECUENTES_SUCCESS';





export const GET_TIPO_CONTENIDO_COMBO_SUCCESS = 'GET_TIPO_CONTENIDO_COMBO_SUCCESS';

export const LOAD_FORMULARIO_LIST_SUCCESS = 'LOAD_FORMULARIO_LIST_SUCCESS';
export const LOAD_FORMULARIO_SUCCESS = 'LOAD_FORMULARIO_SUCCESS';
export const SAVE_FORMULARIO_SUCCESS = 'SAVE_FORMULARIO_SUCCESS';
export const GET_FORMULARIOS_COMBO_SUCCESS = 'GET_FORMULARIOS_COMBO_SUCCESS';
export const BORRAR_FORMULARIO_SUCCESS = 'BORRAR_FORMULARIO_SUCCESS';
export const ACTIVAR_FORMULARIO_SUCCESS = 'ACTIVAR_FORMULARIO_SUCCESS';
export const SET_FILTRO_FORMULARIO = 'SET_FILTRO_FORMULARIO';
export const GET_FORMULARIO_COMBO_SUCCESS = 'GET_FORMULARIO_COMBO_SUCCESS';

export const LOAD_PREGUNTARESPUESTA_LIST_SUCCESS = 'LOAD_PREGUNTARESPUESTA_LIST_SUCCESS';
export const LOAD_PREGUNTARESPUESTA_SUCCESS = 'LOAD_PREGUNTARESPUESTA_SUCCESS';
export const SAVE_PREGUNTARESPUESTA_SUCCESS = 'SAVE_PREGUNTARESPUESTA_SUCCESS';
export const GET_PREGUNTARESPUESTAS_COMBO_SUCCESS = 'GET_PREGUNTARESPUESTAS_COMBO_SUCCESS';
export const BORRAR_PREGUNTARESPUESTA_SUCCESS = 'BORRAR_PREGUNTARESPUESTA_SUCCESS';
export const ACTIVAR_PREGUNTARESPUESTA_SUCCESS = 'ACTIVAR_PREGUNTARESPUESTA_SUCCESS';
export const SET_FILTRO_PREGUNTARESPUESTA = 'SET_FILTRO_PREGUNTARESPUESTA';
export const GET_PREGUNTARESPUESTA_COMBO_SUCCESS = 'GET_PREGUNTARESPUESTA_COMBO_SUCCESS';

export const LOAD_MODULO_LIST_SUCCESS = 'LOAD_MODULO_LIST_SUCCESS';
export const LOAD_MODULO_SUCCESS = 'LOAD_MODULO_SUCCESS';
export const SAVE_MODULO_SUCCESS = 'SAVE_MODULO_SUCCESS';
export const GET_MODULOS_COMBO_SUCCESS = 'GET_MODULOS_COMBO_SUCCESS';
export const BORRAR_MODULO_SUCCESS = 'BORRAR_MODULO_SUCCESS';
export const ACTIVAR_MODULO_SUCCESS = 'ACTIVAR_MODULO_SUCCESS';
export const SET_FILTRO_MODULO = 'SET_FILTRO_MODULO';
export const GET_MODULO_COMBO_SUCCESS = 'GET_MODULO_COMBO_SUCCESS';


export const LOAD_MODULOSLIST_SUCCESS='LOAD_MODULOSLIST_SUCCESS';

export const LOAD_CURSO_LIST_SUCCESS = 'LOAD_CURSO_LIST_SUCCESS';
export const LOAD_CURSO_SUCCESS = 'LOAD_CURSO_SUCCESS';
export const SAVE_CURSO_SUCCESS = 'SAVE_CURSO_SUCCESS';
export const GET_CURSOS_COMBO_SUCCESS = 'GET_CURSOS_COMBO_SUCCESS';
export const BORRAR_CURSO_SUCCESS = 'BORRAR_CURSO_SUCCESS';
export const ACTIVAR_CURSO_SUCCESS = 'ACTIVAR_CURSO_SUCCESS';
export const SET_FILTRO_CURSO = 'SET_FILTRO_CURSO';
export const GET_CURSO_COMBO_SUCCESS = 'GET_CURSO_COMBO_SUCCESS';
export const GET_CURSOS_TIPO_COMBO_SUCCESS='GET_CURSOS_TIPO_COMBO_SUCCESS';

export const LOAD_USUARIO_LIST_SUCCESS = 'LOAD_USUARIO_LIST_SUCCESS';
export const LOAD_USUARIO_SUCCESS = 'LOAD_USUARIO_SUCCESS';
export const SAVE_USUARIO_SUCCESS = 'SAVE_USUARIO_SUCCESS';
export const GET_USUARIOS_COMBO_SUCCESS = 'GET_USUARIOS_COMBO_SUCCESS';
export const BORRAR_USUARIO_SUCCESS = 'BORRAR_USUARIO_SUCCESS';
export const ACTIVAR_USUARIO_SUCCESS = 'ACTIVAR_USUARIO_SUCCESS';
export const SET_FILTRO_USUARIO = 'SET_FILTRO_USUARIO';
export const GET_USUARIO_COMBO_SUCCESS = 'GET_USUARIO_COMBO_SUCCESS';

export const LOAD_PREGUNTASFRECUENTES_LIST_SUCCESS = 'LOAD_PREGUNTASFRECUENTES_LIST_SUCCESS';
export const LOAD_PREGUNTASFRECUENTES_SUCCESS = 'LOAD_PREGUNTASFRECUENTES_SUCCESS';
export const SAVE_PREGUNTASFRECUENTES_SUCCESS = 'SAVE_PREGUNTASFRECUENTES_SUCCESS';
export const GET_PREGUNTASFRECUENTESS_COMBO_SUCCESS = 'GET_PREGUNTASFRECUENTESS_COMBO_SUCCESS';
export const BORRAR_PREGUNTASFRECUENTES_SUCCESS = 'BORRAR_PREGUNTASFRECUENTES_SUCCESS';
export const ACTIVAR_PREGUNTASFRECUENTES_SUCCESS = 'ACTIVAR_PREGUNTASFRECUENTES_SUCCESS';
export const SET_FILTRO_PREGUNTASFRECUENTES = 'SET_FILTRO_PREGUNTASFRECUENTES';
export const GET_PREGUNTASFRECUENTES_COMBO_SUCCESS = 'GET_PREGUNTASFRECUENTES_COMBO_SUCCESS';



export const LOAD_ROLE_LIST_SUCCESS = 'LOAD_ROLE_LIST_SUCCESS';
export const LOAD_ROLE_SUCCESS = 'LOAD_ROLE_SUCCESS';
export const SAVE_ROLE_SUCCESS = 'SAVE_ROLE_SUCCESS';
export const GET_ROLES_COMBO_SUCCESS = 'GET_ROLES_COMBO_SUCCESS';
export const BORRAR_ROLE_SUCCESS = 'BORRAR_ROLE_SUCCESS';
export const ACTIVAR_ROLE_SUCCESS = 'ACTIVAR_ROLE_SUCCESS';
export const SET_FILTRO_ROLE = 'SET_FILTRO_ROLE';
export const GET_ROLE_COMBO_SUCCESS = 'GET_ROLE_COMBO_SUCCESS';

export const LOAD_INSIGNIA_LIST_SUCCESS = 'LOAD_INSIGNIA_LIST_SUCCESS';
export const LOAD_INSIGNIA_SUCCESS = 'LOAD_INSIGNIA_SUCCESS';
export const SAVE_INSIGNIA_SUCCESS = 'SAVE_INSIGNIA_SUCCESS';
export const GET_INSIGNIAS_COMBO_SUCCESS = 'GET_INSIGNIAS_COMBO_SUCCESS';
export const BORRAR_INSIGNIA_SUCCESS = 'BORRAR_INSIGNIA_SUCCESS';
export const ACTIVAR_INSIGNIA_SUCCESS = 'ACTIVAR_INSIGNIA_SUCCESS';
export const SET_FILTRO_INSIGNIA = 'SET_FILTRO_INSIGNIA';
export const GET_INSIGNIA_COMBO_SUCCESS = 'GET_INSIGNIA_COMBO_SUCCESS';

export const LOAD_PREGUNTA_LIST_SUCCESS = 'LOAD_PREGUNTA_LIST_SUCCESS';
export const LOAD_PREGUNTA_SUCCESS = 'LOAD_PREGUNTA_SUCCESS';
export const SAVE_PREGUNTA_SUCCESS = 'SAVE_PREGUNTA_SUCCESS';
export const GET_PREGUNTAS_COMBO_SUCCESS = 'GET_PREGUNTAS_COMBO_SUCCESS';
export const BORRAR_PREGUNTA_SUCCESS = 'BORRAR_PREGUNTA_SUCCESS';
export const ACTIVAR_PREGUNTA_SUCCESS = 'ACTIVAR_PREGUNTA_SUCCESS';
export const SET_FILTRO_PREGUNTA = 'SET_FILTRO_PREGUNTA';
export const GET_PREGUNTA_COMBO_SUCCESS = 'GET_PREGUNTA_COMBO_SUCCESS';


export const LOAD_RESPUESTA_LIST_SUCCESS = 'LOAD_RESPUESTA_LIST_SUCCESS';
export const LOAD_RESPUESTA_SUCCESS = 'LOAD_RESPUESTA_SUCCESS';
export const SAVE_RESPUESTA_SUCCESS = 'SAVE_RESPUESTA_SUCCESS';
export const GET_RESPUESTAS_COMBO_SUCCESS = 'GET_RESPUESTAS_COMBO_SUCCESS';
export const BORRAR_RESPUESTA_SUCCESS = 'BORRAR_RESPUESTA_SUCCESS';
export const ACTIVAR_RESPUESTA_SUCCESS = 'ACTIVAR_RESPUESTA_SUCCESS';
export const SET_FILTRO_RESPUESTA = 'SET_FILTRO_RESPUESTA';
export const GET_RESPUESTA_COMBO_SUCCESS = 'GET_RESPUESTA_COMBO_SUCCESS';

export const LOAD_RESULTADOEXAMEN_LIST_SUCCESS = 'LOAD_RESULTADOEXAMEN_LIST_SUCCESS';
export const LOAD_RESULTADOEXAMEN_SUCCESS = 'LOAD_RESULTADOEXAMEN_SUCCESS';
export const SAVE_RESULTADOEXAMEN_SUCCESS = 'SAVE_RESULTADOEXAMEN_SUCCESS';
export const GET_RESULTADOEXAMENS_COMBO_SUCCESS = 'GET_RESULTADOEXAMENS_COMBO_SUCCESS';
export const BORRAR_RESULTADOEXAMEN_SUCCESS = 'BORRAR_RESULTADOEXAMEN_SUCCESS';
export const ACTIVAR_RESULTADOEXAMEN_SUCCESS = 'ACTIVAR_RESULTADOEXAMEN_SUCCESS';
export const SET_FILTRO_RESULTADOEXAMEN = 'SET_FILTRO_RESULTADOEXAMEN';
export const GET_RESULTADOEXAMEN_COMBO_SUCCESS = 'GET_RESULTADOEXAMEN_COMBO_SUCCESS';

export const LOAD_COMENTARIOS_LIST_SUCCESS = 'LOAD_COMENTARIOS_LIST_SUCCESS';
export const LOAD_COMENTARIOS_SUCCESS = 'LOAD_COMENTARIOS_SUCCESS';
export const SAVE_COMENTARIOS_SUCCESS = 'SAVE_COMENTARIOS_SUCCESS';
export const GET_COMENTARIOSS_COMBO_SUCCESS = 'GET_COMENTARIOSS_COMBO_SUCCESS';
export const BORRAR_COMENTARIOS_SUCCESS = 'BORRAR_COMENTARIOS_SUCCESS';
export const ACTIVAR_COMENTARIOS_SUCCESS = 'ACTIVAR_COMENTARIOS_SUCCESS';
export const SET_FILTRO_COMENTARIOS = 'SET_FILTRO_COMENTARIOS';
export const GET_COMENTARIOS_COMBO_SUCCESS = 'GET_COMENTARIOS_COMBO_SUCCESS';

export const LOAD_CURSOAPRENDIZAJE_LIST_SUCCESS = 'LOAD_CURSOAPRENDIZAJE_LIST_SUCCESS';
export const LOAD_CURSOAPRENDIZAJE_SUCCESS = 'LOAD_CURSOAPRENDIZAJE_SUCCESS';
export const SAVE_CURSOAPRENDIZAJE_SUCCESS = 'SAVE_CURSOAPRENDIZAJE_SUCCESS';
export const GET_CURSOAPRENDIZAJES_COMBO_SUCCESS = 'GET_CURSOAPRENDIZAJES_COMBO_SUCCESS';
export const BORRAR_CURSOAPRENDIZAJE_SUCCESS = 'BORRAR_CURSOAPRENDIZAJE_SUCCESS';
export const ACTIVAR_CURSOAPRENDIZAJE_SUCCESS = 'ACTIVAR_CURSOAPRENDIZAJE_SUCCESS';
export const SET_FILTRO_CURSOAPRENDIZAJE = 'SET_FILTRO_CURSOAPRENDIZAJE';
export const GET_CURSOAPRENDIZAJE_COMBO_SUCCESS = 'GET_CURSOAPRENDIZAJE_COMBO_SUCCESS';

export const LOAD_INSCRIPCION_LIST_SUCCESS = 'LOAD_INSCRIPCION_LIST_SUCCESS';
export const LOAD_INSCRIPCION_SUCCESS = 'LOAD_INSCRIPCION_SUCCESS';
export const SAVE_INSCRIPCION_SUCCESS = 'SAVE_INSCRIPCION_SUCCESS';
export const GET_INSCRIPCIONS_COMBO_SUCCESS = 'GET_INSCRIPCIONS_COMBO_SUCCESS';
export const BORRAR_INSCRIPCION_SUCCESS = 'BORRAR_INSCRIPCION_SUCCESS';
export const ACTIVAR_INSCRIPCION_SUCCESS = 'ACTIVAR_INSCRIPCION_SUCCESS';
export const SET_FILTRO_INSCRIPCION = 'SET_FILTRO_INSCRIPCION';
export const GET_INSCRIPCION_COMBO_SUCCESS = 'GET_INSCRIPCION_COMBO_SUCCESS';
export const CONSTANCIA_INSCRIPCION_SUCCESS='CONSTANCIA_INSCRIPCION_SUCCESS';
export const CONSTANCIAS_INSCRIPCION_SUCCESS='CONSTANCIAS_INSCRIPCION_SUCCESS';

export const LOAD_CURSOOPINION_LIST_SUCCESS = 'LOAD_CURSOOPINION_LIST_SUCCESS';
export const LOAD_CURSOOPINION_SUCCESS = 'LOAD_CURSOOPINION_SUCCESS';
export const SAVE_CURSOOPINION_SUCCESS = 'SAVE_CURSOOPINION_SUCCESS';
export const GET_CURSOOPINIONS_COMBO_SUCCESS = 'GET_CURSOOPINIONS_COMBO_SUCCESS';
export const BORRAR_CURSOOPINION_SUCCESS = 'BORRAR_CURSOOPINION_SUCCESS';
export const ACTIVAR_CURSOOPINION_SUCCESS = 'ACTIVAR_CURSOOPINION_SUCCESS';
export const SET_FILTRO_CURSOOPINION = 'SET_FILTRO_CURSOOPINION';
export const GET_CURSOOPINION_COMBO_SUCCESS = 'GET_CURSOOPINION_COMBO_SUCCESS';

export const LOAD_CURSOCONSTANCIA_LIST_SUCCESS = 'LOAD_CURSOCONSTANCIA_LIST_SUCCESS';
export const LOAD_CURSOCONSTANCIA_SUCCESS = 'LOAD_CURSOCONSTANCIA_SUCCESS';
export const SAVE_CURSOCONSTANCIA_SUCCESS = 'SAVE_CURSOCONSTANCIA_SUCCESS';
export const GET_CURSOCONSTANCIAS_COMBO_SUCCESS = 'GET_CURSOCONSTANCIAS_COMBO_SUCCESS';
export const BORRAR_CURSOCONSTANCIA_SUCCESS = 'BORRAR_CURSOCONSTANCIA_SUCCESS';
export const ACTIVAR_CURSOCONSTANCIA_SUCCESS = 'ACTIVAR_CURSOCONSTANCIA_SUCCESS';
export const SET_FILTRO_CURSOCONSTANCIA = 'SET_FILTRO_CURSOCONSTANCIA';
export const GET_CURSOCONSTANCIA_COMBO_SUCCESS = 'GET_CURSOCONSTANCIA_COMBO_SUCCESS';


export const LOAD_PAGOS_PENDIENTES_LIST_SUCCESS='LOAD_PAGOS_PENDIENTES_LIST_SUCCESS';
export const LOAD_PAGOS_LIST_SUCCESS = 'LOAD_PAGOS_LIST_SUCCESS';
export const LOAD_PAGOS_SUCCESS = 'LOAD_PAGOS_SUCCESS';
export const SAVE_PAGOS_SUCCESS = 'SAVE_PAGOS_SUCCESS';
export const GET_PAGOSS_COMBO_SUCCESS = 'GET_PAGOSS_COMBO_SUCCESS';
export const BORRAR_PAGOS_SUCCESS = 'BORRAR_PAGOS_SUCCESS';
export const ACTIVAR_PAGOS_SUCCESS = 'ACTIVAR_PAGOS_SUCCESS';
export const SET_FILTRO_PAGOS = 'SET_FILTRO_PAGOS';
export const GET_PAGOS_COMBO_SUCCESS = 'GET_PAGOS_COMBO_SUCCESS';

export const INIT_TIMER='INIT_TIMER';
export const SHOW_MODAL_FIN_SESSION='SHOW_MODAL_FIN_SESSION';
export const RENOVAR_SESSION='RENOVAR_SESSION';


export const LOAD_REFERENCIABANCARIA_LIST_SUCCESS = 'LOAD_REFERENCIABANCARIA_LIST_SUCCESS';
export const LOAD_REFERENCIABANCARIA_SUCCESS = 'LOAD_REFERENCIABANCARIA_SUCCESS';
export const SAVE_REFERENCIABANCARIA_SUCCESS = 'SAVE_REFERENCIABANCARIA_SUCCESS';
export const GET_REFERENCIABANCARIAS_COMBO_SUCCESS = 'GET_REFERENCIABANCARIAS_COMBO_SUCCESS';
export const BORRAR_REFERENCIABANCARIA_SUCCESS = 'BORRAR_REFERENCIABANCARIA_SUCCESS';
export const ACTIVAR_REFERENCIABANCARIA_SUCCESS = 'ACTIVAR_REFERENCIABANCARIA_SUCCESS';
export const SET_FILTRO_REFERENCIABANCARIA = 'SET_FILTRO_REFERENCIABANCARIA';
export const GET_REFERENCIABANCARIA_COMBO_SUCCESS = 'GET_REFERENCIABANCARIA_COMBO_SUCCESS';

export const LOAD_TIPOMONEDA_LIST_SUCCESS = 'LOAD_TIPOMONEDA_LIST_SUCCESS';
export const LOAD_TIPOMONEDA_SUCCESS = 'LOAD_TIPOMONEDA_SUCCESS';
export const SAVE_TIPOMONEDA_SUCCESS = 'SAVE_TIPOMONEDA_SUCCESS';
export const GET_TIPOMONEDAS_COMBO_SUCCESS = 'GET_TIPOMONEDAS_COMBO_SUCCESS';
export const BORRAR_TIPOMONEDA_SUCCESS = 'BORRAR_TIPOMONEDA_SUCCESS';
export const ACTIVAR_TIPOMONEDA_SUCCESS = 'ACTIVAR_TIPOMONEDA_SUCCESS';
export const SET_FILTRO_TIPOMONEDA = 'SET_FILTRO_TIPOMONEDA';
export const GET_TIPOMONEDA_COMBO_SUCCESS = 'GET_TIPOMONEDA_COMBO_SUCCESS';


export const LOAD_CURSOTIPOMONEDA_LIST_SUCCESS = 'LOAD_CURSOTIPOMONEDA_LIST_SUCCESS';
export const LOAD_CURSOTIPOMONEDA_SUCCESS = 'LOAD_CURSOTIPOMONEDA_SUCCESS';
export const SAVE_CURSOTIPOMONEDA_SUCCESS = 'SAVE_CURSOTIPOMONEDA_SUCCESS';
export const GET_CURSOTIPOMONEDAS_COMBO_SUCCESS = 'GET_CURSOTIPOMONEDAS_COMBO_SUCCESS';
export const BORRAR_CURSOTIPOMONEDA_SUCCESS = 'BORRAR_CURSOTIPOMONEDA_SUCCESS';
export const ACTIVAR_CURSOTIPOMONEDA_SUCCESS = 'ACTIVAR_CURSOTIPOMONEDA_SUCCESS';
export const SET_FILTRO_CURSOTIPOMONEDA = 'SET_FILTRO_CURSOTIPOMONEDA';
export const GET_CURSOTIPOMONEDA_COMBO_SUCCESS = 'GET_CURSOTIPOMONEDA_COMBO_SUCCESS';

export const LOAD_CRUCIGRAMA_LIST_SUCCESS = 'LOAD_CRUCIGRAMA_LIST_SUCCESS';
export const LOAD_CRUCIGRAMA_SUCCESS = 'LOAD_CRUCIGRAMA_SUCCESS';
export const SAVE_CRUCIGRAMA_SUCCESS = 'SAVE_CRUCIGRAMA_SUCCESS';
export const GET_CRUCIGRAMAS_COMBO_SUCCESS = 'GET_CRUCIGRAMAS_COMBO_SUCCESS';
export const BORRAR_CRUCIGRAMA_SUCCESS = 'BORRAR_CRUCIGRAMA_SUCCESS';
export const ACTIVAR_CRUCIGRAMA_SUCCESS = 'ACTIVAR_CRUCIGRAMA_SUCCESS';
export const SET_FILTRO_CRUCIGRAMA = 'SET_FILTRO_CRUCIGRAMA';
export const GET_CRUCIGRAMA_COMBO_SUCCESS = 'GET_CRUCIGRAMA_COMBO_SUCCESS';

export const LOAD_CRUCIGRAMAPALABRAS_LIST_SUCCESS = 'LOAD_CRUCIGRAMAPALABRAS_LIST_SUCCESS';
export const LOAD_CRUCIGRAMAPALABRAS_SUCCESS = 'LOAD_CRUCIGRAMAPALABRAS_SUCCESS';
export const SAVE_CRUCIGRAMAPALABRAS_SUCCESS = 'SAVE_CRUCIGRAMAPALABRAS_SUCCESS';
export const GET_CRUCIGRAMAPALABRASS_COMBO_SUCCESS = 'GET_CRUCIGRAMAPALABRASS_COMBO_SUCCESS';
export const BORRAR_CRUCIGRAMAPALABRAS_SUCCESS = 'BORRAR_CRUCIGRAMAPALABRAS_SUCCESS';
export const ACTIVAR_CRUCIGRAMAPALABRAS_SUCCESS = 'ACTIVAR_CRUCIGRAMAPALABRAS_SUCCESS';
export const SET_FILTRO_CRUCIGRAMAPALABRAS = 'SET_FILTRO_CRUCIGRAMAPALABRAS';
export const GET_CRUCIGRAMAPALABRAS_COMBO_SUCCESS = 'GET_CRUCIGRAMAPALABRAS_COMBO_SUCCESS';
export const LOAD_CRUCIGRAMA_PALABRAS_SUCCESS  = 'LOAD_CRUCIGRAMA_PALABRAS_SUCCESS';


export const LOAD_USUARIOCURSO_LIST_SUCCESS = 'LOAD_USUARIOCURSO_LIST_SUCCESS';
export const LOAD_USUARIOCURSO_SUCCESS = 'LOAD_USUARIOCURSO_SUCCESS';
export const SAVE_USUARIOCURSO_SUCCESS = 'SAVE_USUARIOCURSO_SUCCESS';
export const GET_USUARIOCURSOS_COMBO_SUCCESS = 'GET_USUARIOCURSOS_COMBO_SUCCESS';
export const BORRAR_USUARIOCURSO_SUCCESS = 'BORRAR_USUARIOCURSO_SUCCESS';
export const ACTIVAR_USUARIOCURSO_SUCCESS = 'ACTIVAR_USUARIOCURSO_SUCCESS';
export const SET_FILTRO_USUARIOCURSO = 'SET_FILTRO_USUARIOCURSO';
export const GET_USUARIOCURSO_COMBO_SUCCESS = 'GET_USUARIOCURSO_COMBO_SUCCESS';

export const SAVE_CORREO_SUCCESS='SAVE_CORREO_SUCCESS';


export const LOAD_CONTABLECUENTA_LIST_SUCCESS = 'LOAD_CONTABLECUENTA_LIST_SUCCESS';
export const LOAD_CONTABLECUENTA_SUCCESS = 'LOAD_CONTABLECUENTA_SUCCESS';
export const SAVE_CONTABLECUENTA_SUCCESS = 'SAVE_CONTABLECUENTA_SUCCESS';
export const GET_CONTABLECUENTAS_COMBO_SUCCESS = 'GET_CONTABLECUENTAS_COMBO_SUCCESS';
export const BORRAR_CONTABLECUENTA_SUCCESS = 'BORRAR_CONTABLECUENTA_SUCCESS';
export const ACTIVAR_CONTABLECUENTA_SUCCESS = 'ACTIVAR_CONTABLECUENTA_SUCCESS';
export const SET_FILTRO_CONTABLECUENTA = 'SET_FILTRO_CONTABLECUENTA';
export const GET_CONTABLECUENTA_COMBO_SUCCESS = 'GET_CONTABLECUENTA_COMBO_SUCCESS';

export const LOAD_CONTABLEGASTO_LIST_SUCCESS = 'LOAD_CONTABLEGASTO_LIST_SUCCESS';
export const LOAD_CONTABLEGASTO_SUCCESS = 'LOAD_CONTABLEGASTO_SUCCESS';
export const SAVE_CONTABLEGASTO_SUCCESS = 'SAVE_CONTABLEGASTO_SUCCESS';
export const GET_CONTABLEGASTOS_COMBO_SUCCESS = 'GET_CONTABLEGASTOS_COMBO_SUCCESS';
export const BORRAR_CONTABLEGASTO_SUCCESS = 'BORRAR_CONTABLEGASTO_SUCCESS';
export const ACTIVAR_CONTABLEGASTO_SUCCESS = 'ACTIVAR_CONTABLEGASTO_SUCCESS';
export const SET_FILTRO_CONTABLEGASTO = 'SET_FILTRO_CONTABLEGASTO';
export const GET_CONTABLEGASTO_COMBO_SUCCESS = 'GET_CONTABLEGASTO_COMBO_SUCCESS';

export const LOAD_CONTABLEREGISTROGASTO_LIST_SUCCESS = 'LOAD_CONTABLEREGISTROGASTO_LIST_SUCCESS';
export const LOAD_CONTABLEREGISTROGASTO_SUCCESS = 'LOAD_CONTABLEREGISTROGASTO_SUCCESS';
export const SAVE_CONTABLEREGISTROGASTO_SUCCESS = 'SAVE_CONTABLEREGISTROGASTO_SUCCESS';
export const GET_CONTABLEREGISTROGASTOS_COMBO_SUCCESS = 'GET_CONTABLEREGISTROGASTOS_COMBO_SUCCESS';
export const BORRAR_CONTABLEREGISTROGASTO_SUCCESS = 'BORRAR_CONTABLEREGISTROGASTO_SUCCESS';
export const ACTIVAR_CONTABLEREGISTROGASTO_SUCCESS = 'ACTIVAR_CONTABLEREGISTROGASTO_SUCCESS';
export const SET_FILTRO_CONTABLEREGISTROGASTO = 'SET_FILTRO_CONTABLEREGISTROGASTO';
export const GET_CONTABLEREGISTROGASTO_COMBO_SUCCESS = 'GET_CONTABLEREGISTROGASTO_COMBO_SUCCESS';

export const LOAD_CURSOS_PROFESOR_LIST_SUCCESS = 'LOAD_CURSOS_PROFESOR_LIST_SUCCESS';

export const LOAD_REGION_LIST_SUCCESS = 'LOAD_REGION_LIST_SUCCESS';
export const LOAD_REGION_SUCCESS = 'LOAD_REGION_SUCCESS';
export const SAVE_REGION_SUCCESS = 'SAVE_REGION_SUCCESS';
export const GET_REGIONS_COMBO_SUCCESS = 'GET_REGIONS_COMBO_SUCCESS';
export const BORRAR_REGION_SUCCESS = 'BORRAR_REGION_SUCCESS';
export const ACTIVAR_REGION_SUCCESS = 'ACTIVAR_REGION_SUCCESS';
export const SET_FILTRO_REGION = 'SET_FILTRO_REGION';
export const GET_REGION_COMBO_SUCCESS = 'GET_REGION_COMBO_SUCCESS';

export const LOAD_PAIS_LIST_SUCCESS = 'LOAD_PAIS_LIST_SUCCESS';
export const LOAD_PAIS_SUCCESS = 'LOAD_PAIS_SUCCESS';
export const SAVE_PAIS_SUCCESS = 'SAVE_PAIS_SUCCESS';
export const GET_PAISS_COMBO_SUCCESS = 'GET_PAISS_COMBO_SUCCESS';
export const BORRAR_PAIS_SUCCESS = 'BORRAR_PAIS_SUCCESS';
export const ACTIVAR_PAIS_SUCCESS = 'ACTIVAR_PAIS_SUCCESS';
export const SET_FILTRO_PAIS = 'SET_FILTRO_PAIS';
export const GET_PAIS_COMBO_SUCCESS = 'GET_PAIS_COMBO_SUCCESS';

export const LOAD_CIUDAD_LIST_SUCCESS = 'LOAD_CIUDAD_LIST_SUCCESS';
export const LOAD_CIUDAD_SUCCESS = 'LOAD_CIUDAD_SUCCESS';
export const SAVE_CIUDAD_SUCCESS = 'SAVE_CIUDAD_SUCCESS';
export const GET_CIUDADS_COMBO_SUCCESS = 'GET_CIUDADS_COMBO_SUCCESS';
export const BORRAR_CIUDAD_SUCCESS = 'BORRAR_CIUDAD_SUCCESS';
export const ACTIVAR_CIUDAD_SUCCESS = 'ACTIVAR_CIUDAD_SUCCESS';
export const SET_FILTRO_CIUDAD = 'SET_FILTRO_CIUDAD';
export const GET_CIUDAD_COMBO_SUCCESS = 'GET_CIUDAD_COMBO_SUCCESS';


export const LOAD_DESCUENTO_LIST_SUCCESS = 'LOAD_DESCUENTO_LIST_SUCCESS';
export const LOAD_DESCUENTO_SUCCESS = 'LOAD_DESCUENTO_SUCCESS';
export const SAVE_DESCUENTO_SUCCESS = 'SAVE_DESCUENTO_SUCCESS';
export const GET_DESCUENTOS_COMBO_SUCCESS = 'GET_DESCUENTOS_COMBO_SUCCESS';
export const BORRAR_DESCUENTO_SUCCESS = 'BORRAR_DESCUENTO_SUCCESS';
export const ACTIVAR_DESCUENTO_SUCCESS = 'ACTIVAR_DESCUENTO_SUCCESS';
export const SET_FILTRO_DESCUENTO = 'SET_FILTRO_DESCUENTO';
export const GET_DESCUENTO_COMBO_SUCCESS = 'GET_DESCUENTO_COMBO_SUCCESS';
